import { render, staticRenderFns } from "./S2_P4_Checkout.vue?vue&type=template&id=61360bac&scoped=true&"
import script from "./S2_P4_Checkout.vue?vue&type=script&lang=js&"
export * from "./S2_P4_Checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61360bac",
  null
  
)

export default component.exports